import {combineReducers} from 'redux'
import types from 'actions/types'

export const isVisible = (state = false, action) => {
  switch (action.type) {
    case types.SHOW_ALLOCATE_CONTACT_LIST_DIALOG:
      return true
    case types.HIDE_ALLOCATE_CONTACT_LIST_DIALOG:
      return false
    default:
      return state
  }
}

export const contactList = (state = null, action) => {
  switch (action.type) {
    case types.SHOW_ALLOCATE_CONTACT_LIST_DIALOG:
      return action.contactList
    case types.HIDE_ALLOCATE_CONTACT_LIST_DIALOG:
      return null
    case types.ALLOCATE_CONTACT_LIST_DIALOG_ALLOCATE_CONTACT_LIST_SUCCESS:
      return null
    case types.ALLOCATE_CONTACT_LIST_DIALOG_ALLOCATE_CONTACT_LIST_FAILURE:
      return null
    default:
      return state
  }
}

export default combineReducers({
  isVisible,
  contactList,
})